// Function to inject the Quasar CSS dynamically
import { disableQuasarCSS,enableQuasarCSS } from '@/utils/quasar';

export default [
    {
      path: '/app',
      // component: () => import('@/layouts/PostLoginLayout.vue'),
      component: () => import('@/layouts/LayoutWrapper.vue'),
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: () => import('@/pages/postlogin/Dashboard.vue'),
          beforeEnter: (to, from, next) => {
            enableQuasarCSS();
            next();
          },
          meta: { requiresAuth: true },
        },
        {
          path: 'downline',
          name: 'Downline',
          component: () => import('@/pages/postlogin/Downline.vue'),
          beforeEnter: (to, from, next) => {
            enableQuasarCSS();
            next();
          }
        },
        {
          path: 'newMembers',
          name: 'NewMembers',
          component: () => import('@/pages/postlogin/NewMembers.vue'),
          beforeEnter: (to, from, next) => {
            // Import Quasar CSS dynamically for other routes
            enableQuasarCSS();
            next();
          }
        },
        {
          path: 'sponsor/changes',
          name: 'SponsorChanges',
          component: () => import('@/pages/postlogin/SponsorChanges.vue'),
          beforeEnter: (to, from, next) => {
            // Import Quasar CSS dynamically for other routes
            enableQuasarCSS();
            next();
          }
        },
        {
          path: 'striking/distance',
          name: 'Striking Distance',
          component: () => import('@/pages/postlogin/StrikingDistance.vue'),
          beforeEnter: (to, from, next) => {
            // Import Quasar CSS dynamically for other routes
            enableQuasarCSS();
            next();
          }
        },
        {
          path: 'product/month',
          name: 'No Of Product Of Month',
          component: () => import('@/pages/postlogin/NoProductOfMonth.vue'),
          beforeEnter: (to, from, next) => {
            // Import Quasar CSS dynamically for other routes
            enableQuasarCSS();
            next();
          }
        },
        {
          path: 'order/three/month',
          name: 'No Of Order In Three Month',
          component: () => import('@/pages/postlogin/NoOrderIn3Months.vue'),
          beforeEnter: (to, from, next) => {
            // Import Quasar CSS dynamically for other routes
            enableQuasarCSS();
            next();
          }
        },
        {
          path: 'order/four/month',
          name: 'No Of Order In Four Month',
          component: () => import('@/pages/postlogin/NoOrderIn4Months.vue'),
          beforeEnter: (to, from, next) => {
            // Import Quasar CSS dynamically for other routes
            enableQuasarCSS();
            next();
          }
        },
        {
          path: 'lrp',
          name: 'Not on LRP',
          component: () => import('@/pages/postlogin/NotOnLRP.vue'),
          beforeEnter: (to, from, next) => {
            // Import Quasar CSS dynamically for other routes
            enableQuasarCSS();
            next();
          }
        },
        {
          path: 'pv/order',
          name: '100 PV Order No LRP',
          component: () => import('@/pages/postlogin/100PVOrderNoLRP.vue'),
          beforeEnter: (to, from, next) => {
            // Import Quasar CSS dynamically for other routes
            enableQuasarCSS();
            next();
          }
        },
        {
          path: 'growth/volume',
          name: 'Top Volume % Growth',
          component: () => import('@/pages/postlogin/TopVolumeGrowth.vue'),
          beforeEnter: (to, from, next) => {
            // Import Quasar CSS dynamically for other routes
            enableQuasarCSS();
            next();
          }
        },
        {
          path: 'rank/tracker',
          name: 'Rank Tracker',
          component: () => import('@/pages/postlogin/RankTracker.vue'),
          beforeEnter: (to, from, next) => {
            // Import Quasar CSS dynamically for other routes
            enableQuasarCSS();
            next();
          }
        },
        {
          path: 'report/frontlinegv',
          name: 'frontlinegv',
          component: () => import('@/pages/postlogin/FrontlineGVReport.vue'),
          beforeEnter: (to, from, next) => {
            // Import Quasar CSS dynamically for other routes
            enableQuasarCSS();
            next();
          },
          meta: { requiresAuth: true },
        },
        {
          path: 'report/frontlinepv',
          name: 'frontlinepv',
          component: () => import('@/pages/postlogin/FrontlinePVReport.vue'),
          beforeEnter: (to, from, next) => {
            // Import Quasar CSS dynamically for other routes
            enableQuasarCSS();
            next();
          },
          meta: { requiresAuth: true },
        },
        {
          path: 'report/earnings',
          name: 'earningdetails',
          component: () => import('@/pages/postlogin/Earnings.vue'),
          beforeEnter: (to, from, next) => {
            // Import Quasar CSS dynamically for other routes
            enableQuasarCSS();
            next();
          },
          meta: { requiresAuth: true },
        },
        {
          path: 'consultant/information',
          name: 'consultantinformation',
          component: () => import('@/pages/postlogin/ConsultantInformation.vue'),
          beforeEnter: (to, from, next) => {
            // Import Quasar CSS dynamically for other routes
            enableQuasarCSS();
            next();
          },
          meta: { requiresAuth: true },
        },
        {
          path: 'register',
          name: 'registerConsultant',
          component: () => import('@/pages/postlogin/Register.vue'),
          beforeEnter: (to, from, next) => {
            enableQuasarCSS().then(() => {
              disableQuasarCSS(); // Ensure Quasar CSS is removed before entering the route
              next();
            });
          },
          meta: { requiresAuth: true },
        },
        {
          path: 'members',
          name: 'mymembers',
          component: () => import('@/pages/postlogin/MembersListing.vue'),
          beforeEnter: (to, from, next) => {
            // Import Quasar CSS dynamically for other routes
            enableQuasarCSS();
            next();
          },
          meta: { requiresAuth: true },
        },
        {
          path: 'geneology',
          name: 'Geneology',
          component: () => import('@/pages/postlogin/Geneology.vue'),
          beforeEnter: (to, from, next) => {
            // Import Quasar CSS dynamically for other routes
            enableQuasarCSS();
            next();
          },
          meta: { requiresAuth: true },
        },
        {
            path: 'profile',  
            name: 'Profile',
            component:() => import('@/pages/postlogin/Profile.vue'),
            beforeEnter: (to, from, next) => {
              // Import Quasar CSS dynamically for other routes
              enableQuasarCSS();
              next();
            }
        },
        {
            path: 'home',  
            name: 'Home',
            component:() => import('@/pages/postlogin/Home.vue'),
            beforeEnter: (to, from, next) => {
              // Import Quasar CSS dynamically for other routes
              enableQuasarCSS();
              next();
            },
            meta: { requiresAuth: true },
        },
        {
            path: 'detailed/geneology',  
            name: 'Detailed Geneology',
            component:() => import('@/pages/postlogin/DetailGeneology.vue'),
            beforeEnter: (to, from, next) => {
              // Import Quasar CSS dynamically for other routes
              enableQuasarCSS();
              next();
            },
            meta: { requiresAuth: true },
        },
        {
            path: 'graphic/tree',  
            name: 'Graphic Tree',
            component:() => import('@/pages/postlogin/GraphicTree.vue'),
            beforeEnter: (to, from, next) => {
              // Import Quasar CSS dynamically for other routes
              enableQuasarCSS();
              next();
            },
            meta: { requiresAuth: true },
        },
      ],
    },
  ];